import getEnvVar from 'utils/getEnvVar';

export const REACT_APP_TRADE = getEnvVar('REACT_APP_TRADE');

export const REACT_APP_GTAG_MEASURE_ID = getEnvVar('REACT_APP_GTAG_MEASURE_ID');

export const REACT_APP_ID = getEnvVar('REACT_APP_ID');
